/**
 * Maps a domain-config module key to its in-app route.
 *
 * Compiled tiles carry an `action_config.module_route`, but it is
 * sometimes omitted (e.g. the Facilities tile ships an empty
 * `action_config`). When that happens we fall back to the tile's
 * `module_required` key so a "module" tile always opens its module.
 */
const MODULE_ROUTES: Record<string, string> = {
  facilities: '/app/facilities',
  'facilities:bookings': '/app/facilities',
  events: '/app/events',
  suppliers: '/app/suppliers',
  'information:contact_groups': '/app/contact-groups',
  access_management: '/app/access-invites',
  'access-invites': '/app/access-invites',
  classifieds: '/app/classifieds',
  documents: '/app/documents',
  gallery: '/app/gallery',
  surveys: '/app/surveys',
  newsstand: '/app/news-stands',
  'news-stands': '/app/news-stands',
  panic: '/app/panic',
  support: '/app/support/requests',
  properties: '/app/my-properties',
  products: '/app/products',
  orders: '/app/orders',
  billing: '/app/invoices',
  'financials:transactions': '/app/invoices',
  'financials:statements': '/app/invoices',
  management: '/app/management',
  map: '/app/map',
  pets: '/app/pets',
  vehicles: '/app/vehicles',
  utilities: '/app/utilities',
  communication: '/app/communication',
};

/** Resolve a module key to its route, or `null` when unknown. */
export function routeForModule(key?: string | null): string | null {
  if (!key) return null;
  return MODULE_ROUTES[key] ?? MODULE_ROUTES[key.toLowerCase()] ?? null;
}
